@if(!item.navCap) {
  <span class="cursor-pointer menuLink text-pr" (click)="onItemSelected(item)" [ngClass]="{
      activeMenu: item.route ? router.isActive(item.route, true) : false
    }"   (contextmenu)=" openInNewTab($event, item)">
  <!-- <i-tabler class="routeIcon icon-18" name="{{ item.iconName }}"></i-tabler> -->
    {{ item.displayName | uppercase }}
    @if(item.children && item.children.length) {
      <span class="down-icon d-flex m-l-auto">
    <mat-icon> expand_more </mat-icon>
  </span>
    }
</span>
}

@if(item.children) {
  <div class="childBox">
    @for(child of item.children; track child) {
      <app-horizontal-nav-item [item]="child" class="ddmenu">
      </app-horizontal-nav-item>
    }
  </div>
}
